module.exports = __webpack_public_path__ + "img/report2-2.3bd7765c.jpg";